import { blue, yellow, green, purple, magenta } from 'globals/colors';
import { TileTabDataProps } from 'ui-elements/tabs/FsTileTabs/FsTileTab/FsTileTab';

export const getActiveColor = (idx: number): string => {
  switch (idx) {
    case 0:
      return purple.BRAND;
    case 1:
      return blue.MAIN;
    case 2:
      return green.MAIN;
    case 3:
      return magenta.BRAND;
    case 4:
      return yellow.MAIN;
    default:
      return purple.BRAND;
  }
};

export const populateTabsData = (
  tabsData: TileTabDataProps[]
): TileTabDataProps[] => {
  return tabsData.map((tabData, idx) => ({
    ...tabData,
    isFirst: idx === 0,
    isActive: idx === 0 || idx === 1,
    activeColor: getActiveColor(idx),
  }));
};
